import React from 'react';
import styled from 'styled-components';

const webAddress = 'https://emerald-road-216311.web.app/';

const TermsInner = styled.div`
  overflow: auto;
  max-height: 400px;
  font-size: 17px;
  h1 {
    text-align: center;
    line-height: 1;
    font-size: 45px;
    margin-bottom: 15px;
  }
  h2 {
    font-size: 20px;
    color: #444;
  }
  i {
    font-size: 15px;
    text-align: center;
    display: block;
    width: 100%;
  }
  p {
    font-size: 16px;
  }
`;

const TermsWrapper = styled.div`
  position: relative;
  background: #fff;
  x-index: 99999;
  width: calc(100% - 40px);
  max-width: 700px;
  margin: 30px auto;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
  padding: 20px;
  padding-bottom: 70px;
`;

const Controls = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  background: #fff;
  width: calc(100% - 40px);
  padding: 10px;
`;

const Button = styled.button`
  background: #0093dd;
  display: block;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  padding: 10px;
  width: 100px;
  border: none;
  margin: 0 auto;
  &:focus {
    outline: none;
  }
  &:hover {
    background: #0165fc;
  }
`;

const t = 'Smart Tracker';

const Policy: React.FC<{ close: () => void }> = (props) => {
  return (
    <TermsWrapper>
      <TermsInner>
        <h1>Лицензионный договор</h1>
        <i>на право использования Сервисов Smart Tracker</i>
        <p>
          Настоящий лицензионный договор является офертой ФЛП «Кузин Виталий Владимирович»,
          именуемого в дальнейшем «Лицензиар», физическому или юридическому лицу, пользователю сайта
          в сети Интернет, расположенного по адресу <a href={webAddress}>{webAddress}</a>,
          именуемому в дальнейшем «Лицензиат» и считается заключенным с момента ее акцепта
          Лицензиатом. Под акцептом в целях настоящего Договора понимается факт оплаты Лицензиатом
          вознаграждения по настоящему Договору.
        </p>
        <h2>ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ</h2>
        <p> Далее по тексту будут употребляться следующие термины и определения:</p>
        <p>
          1.1. «Лицензиат» — физическое или юридическое лицо, приобретающее у Лицензиара за
          вознаграждение право использования Программного обеспечения в пределах, установленных в
          настоящем Договоре;
        </p>
        <p>
          1.2. «Лицензиар» – правообладатель Программного обеспечения, передаваемой по настоящему
          Договору;
        </p>
        <p>
          1.3. «Программное обеспечение (ПО)» – программа «Smart Tracker» - система учета рабочего
          времени и контроля персонала, правообладателем которой является Лицензиар. ПО в целом и
          все его составные части являются результатами интеллектуальной деятельности и защищаются
          законодательством Украины и международными соглашениями в сфере охраны и защиты прав на
          результаты интеллектуальной деятельности;
        </p>
        <p>
          1.4. «Сервер» - оборудование Лицензиара, на котором установлено Программное обеспечение,
          доступное на сайте Лицензиара в сети Интернет по адресу: {webAddress}.
        </p>
        <p>
          1.5. «Прайс-лист» - документ, содержащий сведения о действующих тарифных планах и размере
          лицензионного вознаграждения Лицензиара в зависимости от количества Рабочих мест,
          функциональных возможностей и сроков использования ПО. Действующая редакция документа
          публикуется в сети Интернет по адресу: <a href={webAddress}>{webAddress}</a> в разделе
          "Подробнее о ценах"
        </p>
        <p>
          1.6. «Тарифный план» – неотъемлемая часть Прайс-листа, содержащая описание доступных
          Лицензиату функциональных возможностей ПО, определенного количества Рабочих мест и сроков
          использования ПО.
        </p>
        <p>
          1.7. «Рабочее место» - учетная запись, созданная на оборудовании Лицензиата (персональный
          компьютер, ноутбук, и т.д.), в отношении которой ПО осуществляет контроль и ведение учета
          рабочего времени сотрудников.
        </p>
        <h2>2. ПРЕДМЕТ ДОГОВОРА</h2>
        <p>
          2.1. Лицензиар передает Лицензиату право использования (простую (неисключительную)
          лицензию) ПО (далее – Лицензия), ограниченное правом запуска и настройки ПО, а Лицензиат
          принимает и оплачивает переданные ему права.
        </p>
        <p>
          2.2. Право Лицензиата на использование ПО, не включает никакого разрешения, права или
          полномочий:
        </p>
        <ul>
          <li>2.2.1. Разъединять, перекомпоновывать или деассемблировать ПО.</li>
          <li>2.2.2. Передавать право использования ПО третьим лицам.</li>
        </ul>
        <p>
          2.3. Лицензиар предоставляет право Лицензиату использовать новые версии ПО. Новые версии
          предоставляются в качестве обновлений, доступных для использования на Сервере Лицензиара в
          течение срока действия Лицензии.
        </p>
        <p>2.4. Территория использования ПО: территория всего мира.</p>
        <h2>3. ПРАВА И ОБЯЗАННОСТИ СТОРОН</h2>
        <p>3.1. Лицензиар принимает на себя следующие обязательства:</p>
        <p>
          3.1.1. Предоставить Лицензиату Лицензию на условиях, изложенных в настоящем Договоре.
          Лицензия считается предоставленной Лицензиату с момента получения Лицензиаром
          лицензионного вознаграждения в соответствии с разделом 4 настоящего Договора.
        </p>
        <p>
          3.1.2. Предоставить Лицензиату необходимое пространство на Сервере для его использования в
          целях обработки и хранения информации, получаемой с использованием ПО.
        </p>
        <p>
          3.1.3. Обеспечивать сохранность и конфиденциальность находящейся на Сервере информации,
          обработанной в результате использования Лицензиатом ПО до момента получения уведомления
          Лицензиата о необходимости уничтожения такой информации или достижения предельного срока
          хранения информации согласно выбранного Лицензиатом Тарифного плана.
        </p>
        <p>3.2. Лицензиар вправе:</p>
        <ul>
          <li>
            3.2.1. Осуществлять контроль использования Лицензиатом прав, полученных по настоящему
            Договору.
          </li>
          <li>
            3.2.2. В случае нарушения Лицензиатом предусмотренных настоящим Договором условий
            (способов) использования ПО, лишить Лицензиата Лицензии, направив письменное уведомление
            о досрочном расторжении настоящего Договора.
          </li>
          <li>
            3.2.3. Использовать название и оценки сервиса Лицензиата в своих маркетинговых
            материалах и прочих устных, электронных или письменных рекламных кампаниях, которые
            будут включать название Заказчика и краткое описание предоставленных сервисов.
          </li>
          <li>
            3.2.4. Модифицировать или выпускать новые версии ПО в любое время и по любой причине, в
            том числе в целях удовлетворения потребностей Лицензиата или требований
            конкурентоспособности, в целях соблюдения действующего законодательства. Лицензиар
            оставляет за собой право по своему усмотрению добавлять новые свойства и функциональные
            возможности ПО или удалять из ПО уже существующие свойства или функциональные
            возможности.
          </li>
          <li>
            3.2.5. Проводить профилактические работы на Сервере, которые могут сделать невозможным
            использование Лицензиатом ПО. При этом Лицензиар будет предпринимать все возможные меры
            к проведению профилактических работ в ночное время или в выходные дни, чтобы не
            создавать препятствий для использования Лицензиатом ПО.
          </li>
        </ul>
        <p>3.3. Лицензиат принимает на себя следующие обязательства:</p>
        <ul>
          <li>
            3.3.1. Не нарушать условий (способов) использования ПО, установленных настоящим
            Договором.
          </li>
          <li>
            3.3.2. Не передавать третьим лицам пароли и логины, используемые для доступа к Серверу,
            обеспечивать их конфиденциальность.
          </li>
          <li>3.3.3. Не передавать право использования ПО третьим лицам.</li>
        </ul>
        <p>3.4. Лицензиат вправе:</p>
        <ul>
          <li>3.4.1. Использовать ПО в пределах прав, предоставленных настоящим Договором.</li>
          <li>
            3.4.2. Использовать ПО в течение срока действия Лицензии и в пределах максимального
            количества Рабочих мест, предоставленных по настоящему Договору.
          </li>
          <li>
            3.4.3. По своему усмотрению изменять максимальное количество Рабочих мест, используя
            настройки на Сервере Лицензиара. В случае изменения Лицензиатом максимального количества
            используемых Рабочих мест срок действия Лицензии пересчитывается на Сервере Лицензиара
            автоматически в пределах оплаченной суммы лицензионного вознаграждения. Лицензиат
            соглашается с тем, что в случае изменения Лицензиатом количества используемых Рабочих
            мест, сведения о количестве Рабочих мест и сроке действия Лицензии будут указаны в
            Личном кабинете Лицензиата, а соответствующие изменения вступают в юридическую силу без
            дополнительного согласования и письменного оформления Сторонами. При этом, сведения о
            количестве Рабочих мест и сроке действия Лицензии, указанные в оплаченном Лицензиатом
            счете, утрачивают юридическую силу и не будут применяться.
          </li>
          <li>
            3.4.4. Обрабатывать и хранить на Сервере информацию, получаемую с использованием ПО.
          </li>
        </ul>
        <h2>4. ЛИЦЕНЗИОННОЕ ВОЗНАГРАЖДЕНИЕ И УСЛОВИЯ ОПЛАТЫ</h2>
        <p>
          4.1. Стоимость лицензионного вознаграждения по Договору определяется действующим
          Прайс-листом Лицензиара и зависит от выбранного Лицензиатом Тарифного плана.
        </p>
        <p>
          4.2. После того, как Лицензиат сформирует с помощью Сервера заказ на необходимые ему
          функции ПО, Лицензиар направляет Лицензиату счет для оплаты с указанием размера
          лицензионного вознаграждения, максимального количества Рабочих мест для использования ПО и
          срока действия Лицензии, который должен быть оплачен Лицензиатом в полной объеме в течение
          пяти рабочих дней с момента его направления. Оплата счета подтверждает факт предоставления
          Лицензиаром права использования ПО Лицензиату на условиях, предусмотренных настоящим
          Договором. При этом, предоставление Лицензиаром дополнительных документов, подтверждающих
          передачу Лицензиату права использования ПО, не предусмотрено. В случае, если Лицензиат не
          оплачивает счет в указанный срок, такой счет может быть аннулирован Лицензиаром, о чем
          Лицензиар уведомляет Лицензиата любым доступным способом.
        </p>
        <p>
          4.3. Оплата вознаграждения производится на основании выставленного счета в размере 100%
          стоимости лицензионного вознаграждения по Договору.
        </p>
        <p>
          4.4. Расчеты между Сторонами осуществляются путем сервиса приема платежей FONDY. Оплата
          вознаграждения считается произведенной Лицензиатом с момента зачисления денежных средств
          на расчетный счет Лицензиара в системе FONDY.
        </p>
        <h2>5. ГАРАНТИИ И ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ</h2>
        <p>
          5.1. Лицензиар гарантирует, что он является законным обладателем передаваемых по
          настоящему Договору прав и гарантирует освобождение от претензий третьих лиц и организаций
          относительно нарушения авторских и имущественных прав.
        </p>
        <p>
          5.2. Лицензиар не несёт ответственности за причинение вреда или любые случайные, особые,
          непрямые или косвенные убытки, включая без ограничения, потерю прибыли, данных, перерыв в
          коммерческой деятельности или иные коммерческие убытки, или ущерб, возникшие или связанные
          с использованием или невозможностью использовать ПО Лицензиара по любой причине. В любом
          случае общая компенсационная ответственность Лицензиара перед Лицензиатом ограничивается
          суммой, уплаченной Лицензиатом за право использования ПО, приобретаемое по настоящему
          Договору.
        </p>
        <p>
          5.3. Лицензиар в соответствии с условиями настоящего Договора обязуется передать
          Лицензиату право использования ПО в том качественном состоянии, какое оно имеет на момент
          подписания настоящего Договора. Подписанием настоящего Договора Лицензиат подтверждает,
          что до момента заключения Договора проверил и удовлетворен функциональными возможностями
          ПО, ознакомлен с минимальными техническими требованиями оборудования, необходимыми для его
          установки и эффективной работы.
        </p>
        <p>
          5.4. Лицензиар гарантирует отсутствие в ПО заведомо вредоносного кода, предназначенного
          для порчи программно-аппаратных средств Лицензиата или передачи третьим лицам
          конфиденциальной информации.
        </p>
        <p>
          5.5. Лицензиар предупреждает Лицензиата, что ПО является технически сложным программным
          комплексом, состоящим из множества компонентов и подсистем, поэтому при его использовании
          Лицензиатом могут быть выявлены некоторые недостатки, которые в разумные сроки будут
          устраняться Лицензиаром, в том числе путем выпуска сервисных пакетов и обновлений.
          Устранение Лицензиаром недостатков ПО не предполагает выполнения каких-либо работ на
          оборудовании Лицензиата.
        </p>
        <p>
          5.6. В случае не использования Лицензиатом ПО (отсутствие у Лицензиата необходимости в
          этом; невозможность использования, обусловленная техническими или иными проблемами со
          стороны Лицензиата или третьих лиц) стоимость лицензионного вознаграждения Лицензиаром не
          возвращается. В случае блокирования Учетной записи Лицензиата в связи с нарушением
          настоящего Договора, возврат стоимости лицензионного вознаграждения Лицензиаром не
          производится.
        </p>
        <h2>6. СРОК ДЕЙСТВИЯ ЛИЦЕНЗИИ И ПРЕКРАЩЕНИЕ ДОГОВОРА</h2>
        <p>
          6.1. Срок действия настоящего Договора равен сроку действия Лицензии, указанному в счете,
          оплаченном Лицензиатом в соответствии с разделом 4 Договора, либо, в случае изменения
          Лицензиатом количества Рабочих мест в соответствии с пунктом 3.4.3 Договора, в Личном
          кабинете Лицензиата на Сервере Лицензиара.
        </p>
        <p>
          6.2. Окончание срока действия Лицензии влечет прекращение действия настоящего Договора и
          всех прав Лицензиата, предусмотренных настоящим Договором.
        </p>
        <p>
          6.3. В случае окончания срока действия Лицензии для продолжения пользования ПО Лицензиат
          обязан заключить с Лицензиаром новый договор в порядке, предусмотренном п.4.2 настоящего
          Договора.
        </p>
        <h2>7. ОТВЕТСТВЕННОСТЬ СТОРОН</h2>
        <p>
          7.1. За неисполнение или ненадлежащее исполнение обязательств по настоящему Договору
          Стороны несут ответственность в соответствии с настоящим Договором, а в случаях им не
          урегулированных, в соответствии с законодательством Украины.
        </p>
        <p>
          7.2. Лицензиар имеет право в одностороннем порядке отозвать переданные по настоящему
          Договору права и отказаться от исполнения настоящего Договора, письменно уведомив об этом
          Лицензиата, в случае полного либо частичного неисполнения Лицензиатом своих обязательств,
          в том числе предусмотренных п.п.3.3.1 – 3.3.3 настоящего Договора.
        </p>
        <p>8. ОБСТОЯТЕЛЬСТВА НЕПРЕОДОЛИМОЙ СИЛЫ</p>
        <p>
          8.1. Стороны освобождаются от ответственности за частичное, полное неисполнение или
          ненадлежащее исполнение обязательств по настоящему Договору, если надлежащее исполнение
          оказалось невозможным вследствие обстоятельств непреодолимой силы, т.е. чрезвычайных и
          непредотвратимых при данных условиях обстоятельств, как то: стихийные бедствия, пожары,
          военные действия, революции, забастовки, запретительные акты государственной власти и
          управления, пожарная, транспортная или производственная авария и тому подобные
          обстоятельства, не зависящие от воли Сторон и препятствующие исполнению или надлежащему
          исполнению Стороной своих обязательств.
        </p>
        <p>
          8.2. Сторона, для которой создалась невозможность исполнения обязательств по настоящему
          Договору, обязана сообщить другой Стороне о наступлении указанных выше обстоятельств
          немедленно.
        </p>
        <p>
          8.3. При наступлении обстоятельств непреодолимой силы срок исполнения обязательств по
          настоящему Договору продляется соразмерно времени действия таких обстоятельств.
        </p>
        <p>
          8.4. Стороны обязаны незамедлительно известить друг друга об окончании действия
          обстоятельств непреодолимой силы с уточнением срока исполнения обязательств по настоящему
          Договору, прерванных или приостановленных ввиду наступления таких обстоятельств.
        </p>
        <h2>9. ПОРЯДОК РАЗРЕШЕНИЯ СПОРОВ</h2>
        <p>
          9.1. Все споры и разногласия, которые могут возникнуть из настоящего Договора или в связи
          с ним, по возможности решаются путем переговоров между Сторонами.
        </p>
        <p>
          9.2. Претензионный порядок урегулирования споров является обязательным. Срок ответа на
          претензию – 30 (тридцать) календарных дней с момента ее получения Стороной.
        </p>
        <p>
          9.3. В случае невозможности решения путем переговоров, все споры, разногласия или
          требования, возникающие из данного Договора или в связи с ним, подлежат разрешению в суде
          по месту нахождения Лицензиара в соответствии с законодательством Украины.
        </p>
        <h2>10. ПРОЧИЕ УСЛОВИЯ</h2>
        <p>
          10.1. Акцептуя настоящий Договор, Лицензиат соглашается со всеми его условиями без
          оговорок и исключений, а также с положениями Политики конфиденциальности, опубликованной
          Лицензиаром в сети Интернет на сайте по адресу: {webAddress} в разделе "Политика
          конфиденциальности", которые не противоречат условиям настоящего Договора, а также ЗУ от
          01.01.2022 г № 2297-VI «О защите персональных данных».
        </p>
        <p>
          10.2. Лицензиат не имеет права передавать свои права и обязанности по настоящему Договору
          третьей стороне без письменного согласия Лицензиара.
        </p>
      </TermsInner>
      <Controls>
        <Button type="button" onClick={props.close}>
          Ознакомлен
        </Button>
      </Controls>
    </TermsWrapper>
  );
};

export default Policy;
